import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TopNavComponent } from './layout/top-nav/top-nav.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { ActiveIngredientComponent } from './sections/active-ingredient/active-ingredient.component';
import { HeroSectionComponent } from './sections/hero-section/hero-section.component';
import { ButtonComponent } from './components/button/button.component';
import { FormsConcentraionsComponent } from './sections/forms-concentraions/forms-concentraions.component';
import { IndecationsComponent } from './sections/indecations/indecations.component';
import { InteractionsComponent } from './sections/interactions/interactions.component';
import { TrialsComponent } from './sections/trials/trials.component';
import { GuidlinesComponent } from './sections/guidlines/guidlines.component';
import { RelatedProductsComponent } from './sections/related-products/related-products.component';
import { DownloadAppComponent } from './sections/download-app/download-app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { TextTrimerPipe } from './pipes/text-trimer.pipe';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { HomePageComponent } from './layout/home-page/home-page.component';
import { LoadingComponent } from './shared/loading/loading.component';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { ReferencesComponent } from './sections/references/references.component';
// import { AngularFirestoreModule } from '@angular/fire/firestore';

@NgModule({
  declarations: [
    AppComponent,
    TopNavComponent,
    NavbarComponent,
    ActiveIngredientComponent,
    HeroSectionComponent,
    ButtonComponent,
    FormsConcentraionsComponent,
    IndecationsComponent,
    InteractionsComponent,
    TrialsComponent,
    GuidlinesComponent,
    RelatedProductsComponent,
    DownloadAppComponent,
    FooterComponent,
    TextTrimerPipe,
    NotFoundComponent,
    HomePageComponent,
    LoadingComponent,
    ReferencesComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    // AngularFirestoreModule

  ],
  providers: [HttpClientModule,Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
